import type { Reader } from '@/api/client';
import type { FilterColumnType } from '@/lib/tableFilters/operators';
import { contractorDisplayName } from '@/utils/contractorDisplayName';
import { readerCatalogTableDisplayName } from '@/utils/readerCatalogTableDisplayName';
import { READER_COOPERATION_STATES } from '@/utils/readerCooperationStates';

export function getReadersCatalogOptionsForColumn(
  columnId: string,
  filterType: FilterColumnType,
  readers: Reader[]
): string[] {
  switch (filterType) {
    case 'select': {
      if (columnId !== 'state') return [];
      const set = new Set<string>(READER_COOPERATION_STATES);
      for (const r of readers) {
        if (r.cooperation_state) set.add(r.cooperation_state);
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'ru'));
    }
    case 'text': {
      if (columnId === 'name') {
        const set = new Set<string>();
        for (const r of readers) {
          const d = readerCatalogTableDisplayName(r);
          if (d.trim()) set.add(d);
        }
        return Array.from(set).sort((a, b) => a.localeCompare(b, 'ru'));
      }
      if (columnId === 'studio') {
        const set = new Set<string>();
        for (const r of readers) {
          if (r.contractor) {
            const d = contractorDisplayName(r.contractor);
            if (d.trim()) set.add(d);
          }
        }
        return Array.from(set).sort((a, b) => a.localeCompare(b, 'ru'));
      }
      return [];
    }
    default:
      return [];
  }
}
